import axios from "axios";
import { getQueryCampaignId } from "modules/EmailBrowser/utils";
import { objectToQueryParams } from "utils";
import { API_BASE_PUBLISH } from "../../constants/index";
import http from "./HttpService";

export const exportWidgetsService = (promotionCodes: string[]) => {
  const payload = new FormData();
  payload.append("promotion_codes", JSON.stringify(promotionCodes));
  payload.append("campaign_id", getQueryCampaignId().toString());
  return http.post(API_BASE_PUBLISH + "export_widget/", payload);
};

// Groups Listing
let cancelTokenGroupsList: any;
export const getSalesXGroupsListsService = (queryParams: any) => {
  const params = objectToQueryParams(queryParams);

  //Check if there are any previous pending requests
  if (typeof cancelTokenGroupsList != typeof undefined) {
    cancelTokenGroupsList && cancelTokenGroupsList.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenGroupsList = axios.CancelToken.source();

  return http.get(API_BASE_PUBLISH + `groups_list/?` + params, {
    cancelToken: cancelTokenGroupsList.token,
  });
};

// Users Listing (Global)
let cancelTokenUsersList: any;
export const getUsersListForExportWidgetsService = (queryParams: any) => {
  const params = objectToQueryParams(queryParams);

  //Check if there are any previous pending requests
  if (typeof cancelTokenUsersList != typeof undefined) {
    cancelTokenUsersList && cancelTokenUsersList.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenUsersList = axios.CancelToken.source();

  return http.get(API_BASE_PUBLISH + `users_list/?` + params, {
    cancelToken: cancelTokenUsersList.token,
  });
};

// Group's Users Listing
let cancelTokenGroupDetails: any;
export const getGroupDetailsService = (params: any) => {
  const groupId = params.groupId;
  delete params.groupId;
  const queryParams = objectToQueryParams(params);

  //Check if there are any previous pending requests
  if (typeof cancelTokenGroupDetails != typeof undefined) {
    cancelTokenGroupDetails && cancelTokenGroupDetails.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenGroupDetails = axios.CancelToken.source();

  return http.get(API_BASE_PUBLISH + `widget_group_detail/${groupId}/?${queryParams}`, {
    cancelToken: cancelTokenGroupDetails.token,
  });
};

// Create
export const createGroupForExportWidgetsService = (groupName: string) => {
  let payload: any = {};
  if (!groupName) payload.name = "";
  return http.post(API_BASE_PUBLISH + "widget_group_create/", payload, {});
};

// Update
export const updateGroupsService = (params: any) => {
  const payload: any = {};
  // Name
  if (params.groupName) {
    payload.name = params.groupName;
  }
  // Add Users Case
  if (params.addUsers?.length) {
    payload.addUsers = [...params.addUsers];
    payload.saveAll = params.saveAll;
    payload.exceptUsers = params.exceptUsers;
  }
  // Delete Users Case
  if (params.deleteUsers?.length) {
    payload.deleteUsers = [...params.deleteUsers];
    payload.deleteAll = params.deleteAll;
    payload.exceptUsers = params.exceptUsers;
  }

  if (params.saveAll) {
    payload.addUsers = [...params.addUsers];
    payload.saveAll = params.saveAll;
    payload.exceptUsers = params.exceptUsers;
  }

  if (params.deleteAll) {
    payload.deleteUsers = [...params.deleteUsers];
    payload.deleteAll = params.deleteAll;
    payload.exceptUsers = params.exceptUsers;
  }

  if (params.exceptUsers && params?.exceptUsers?.length > 0 && !!!params.saveAll && params.saveFlag === true) {
    payload.exceptUsers = params.exceptUsers;
    payload.saveAll = true;
  }

  if (params.exceptUsers && params?.exceptUsers.length > 0 && !!!params.deleteAll && params.saveFlag === false) {
    payload.exceptUsers = params.exceptUsers;
    payload.deleteAll = true;
  }
  if (params.personalityType?.length) {
    // Personality Filter
    payload.personalityType = [...params.personalityType];
  }
  // Search Term
  if (params.searchTerm) {
    payload.searchTerm = params.searchTerm;
  }
  return http.post(API_BASE_PUBLISH + `widget_group_update/${params.groupId}/`, payload, {});
};

// Delete
let cancelTokenDelete: any;

export const deleteGroupsService = (groupId: any) => {
  const payload = new FormData();

  //Check if there are any previous pending requests
  if (typeof cancelTokenDelete != typeof undefined) {
    cancelTokenDelete && cancelTokenDelete.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenDelete = axios.CancelToken.source();

  return http.post(API_BASE_PUBLISH + `widget_group_delete/${groupId}/`, payload, {
    cancelToken: cancelTokenDelete.token,
  });
};

// Status
export const exportWidgetUpdateStatusService = (params: any) => {
  const payload: any = {};
  payload["campaignId"] = params.campaignId;
  if (params.searchTerm !== "") {
    payload["searchTerm"] = params.searchTerm;
  }

  if (params?.selectAllGroups) {
    payload["selectAllGroups"] = params.selectAllGroups;
    if (params?.exceptGroups?.length > 0) {
      payload["exceptGroups"] = params.exceptGroups;
    }
  }
  if (params?.removeAllGroups) {
    payload["removeAllGroups"] = params.removeAllGroups;
    if (params?.exceptGroups?.length > 0) {
      payload["exceptGroups"] = params.exceptGroups;
    }
  }

  if (params?.selectAllUsers) {
    payload["selectAllUsers"] = params.selectAllUsers;
    if (params?.exceptUsers?.length > 0) {
      payload["exceptUsers"] = params.exceptUsers;
    }
  }
  if (params?.removeAllUsers) {
    payload["removeAllUsers"] = params.removeAllUsers;
    if (params?.exceptUsers?.length > 0) {
      payload["exceptUsers"] = params.exceptUsers;
    }
  }

  if (params?.addUsers?.length > 0) {
    payload["addUsers"] = params.addUsers;
  }
  if (params?.removeUsers?.length > 0) {
    payload["removeUsers"] = params.removeUsers;
  }

  if (params?.addGroups?.length > 0) {
    payload["addGroups"] = params.addGroups;
  }
  if (params?.removeGroups?.length > 0) {
    payload["removeGroups"] = params.removeGroups;
  }

  return http.post(API_BASE_PUBLISH + `export_widget/`, payload);
};
